module.exports = __webpack_public_path__ + "Icon_BBTS@2x.png?b9b8597aa3241a8a43724c6666642335";